import { Component, ContentChild, ElementRef, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent {
  @Input() title: string = '';
  @Input() size: 'sm' | 'md' | 'lg' | 'xl' | 'full' = 'md';
  @Input() disableBodyClass: boolean = false;
  @Input() backdropBlur: boolean = false;
  @Input() fullHeightMobile: boolean = true;
  @Output() onClose = new EventEmitter<void>();

  @ContentChild('modal-header', { static: false, read: ElementRef }) modalHeader: ElementRef | undefined;
  
  get hasCustomHeader(): boolean {
    return !!this.modalHeader;
  }

  get modalSizeClasses(): string {
    const sizeClasses = {
      'sm': 'max-w-sm',
      'md': 'max-w-2xl',
      'lg': 'max-w-4xl',
      'xl': 'max-w-6xl',
      'full': 'max-w-full mx-4'
    };
    
    const mobileClass = this.fullHeightMobile ? 'max-h-screen' : '';
    
    return `${sizeClasses[this.size]} ${mobileClass} w-full`;
  }

  close(): void {
    this.onClose.emit();
  }
} 